import React from 'react'
import Banner from '../assets/images/cbanner.jpg'

const CatalogueHeading = () => {
  return (
    <>
      <div className="overflow-x-hidden">
        <div className="w-screen flex justify-center items-center h-[40vh]">
          <p className="text-3xl absolute font-semibold text-white lg:text-5xl z-40">Catalogue</p>
          <div className="sect w-full h-full brightness-[0.2]"></div>
        </div>
      </div>
    </>
  );
}

export default CatalogueHeading